import React from 'react';
import styled, { keyframes } from 'styled-components';
import em from 'polished/lib/helpers/em';
import FlowStripe from '@flow/components/ticker/FlowStripe';
import { Link } from 'react-static';
import SimpleCarousel from "@flow/components/carousel/SimpleCarousel";

const slideForward = keyframes`
  0%,
  100% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(10px, 0);
  }
`;

const CarouselWrapper = styled.div`
  .slick-vertical .slick-slide {
    border: none;
  }
  
  .slick-slider .slick-slide {
    display: none;
  }
  
  .slick-slider .slick-slide:first-child {
    display: block;
  }
  
  .slick-initialized.slick-slider .slick-slide,
  .slick-initialized.slick-slider .slick-slide:first-child {
    display: block;
  }
`;

const Effect = styled.div`
  width: calc(50% + 3.3em);
  position: relative;
  background-image: url(${props => props.theme.isRetina ? props.image['large'] : props.image['medium']});
  background-size: cover;
`;

const Figure = styled.figure`
  padding-top: 100%;
`;

const StripeWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 6.6em;
  overflow: hidden;
`;

const BottomStripe = styled.div`
  border-top: 0.2em solid ${props => props.theme.highlightColor};
  border-bottom: 0.2em solid ${props => props.theme.highlightColor};
  overflow: hidden;
`;

const ReadMore = styled.span`
  font-size: 2.1em;
  line-height: 1.3;
  display: block;
  margin-top: ${em(2, 2.1)};
  
  &:after {
    content: '→';
    margin-left: ${em(1, 2.1)};
    font-family: Flow-Poster-Bold;
    display: inline-block;
    // transform: scale(1.9);
  }
  
  @media (max-width: 1200px) {
    font-size: 1.8em;
  }
`;

const Content = styled.div`
  width: calc(50% - 3.3em);
  a {
    display: block;
    box-sizing: border-box;
    height: 100%;
    padding: 0 3em 3em;
    
    &:${props => props.theme.hoverProperty} {
      background-color: ${props => props.theme.highlightColor};
      
      ${ReadMore}:after {
        animation: ${slideForward} 0.6s ease-in-out 1;
      }
    }
  }
`;

const ContentContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  /*display: flex;
  
  */
`;

const ContentFooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  span {
    font-size: 2.8em;
    font-family: Flow-Poster-Bold;
    text-transform: uppercase;
    line-height: ${em(3.2, 2.8)};
    
    @media (max-width: 1920px) {
      font-size: ${28/(1920*0.01)}vw;
    }
    
    @media (max-width: 1200px) {
      font-size: 1.8em;
    }
  }
`;

const TitleWrapper = styled.div`
  text-align: center;
  padding: 9.3em 3em 5em;
  display: flex;
  flex: 1;
  align-items: center;
`;

const Title = styled.h2`
  text-align: center;
  text-transform: uppercase;
  font-size: 15em;
  font-family: Flow-Inverted;
  //margin-top: ${em(6, 20)};
  
  @media (max-width: 1920px) {
    font-size: ${150/(1920*0.01)}vw;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: ${props => props.direction};
  width: 100%;
  
  @media (max-width: 760px) {
    flex-direction: column;
    
    ${Effect}, ${Content} {
      width: 100%;
    }
    
    ${StripeWrapper} {
      display: none;
    }
    
    ${TitleWrapper} {
      padding: 5em 3em;
    }
    
    ${Content} {
      a {
        padding-bottom: 0;
      }
    }
    
    ${ContentFooterContent} {
      display: none;
    }
  }
  
  @media (max-width: 530px) {    
    ${Title} {
      font-size: 4.14em;
    }
  }
`;

const Hero = ({
  heroes,
}: any) => {
  if (!heroes || heroes.length === 0) {
    return null;
  } else {
    const alignment = 'row';

    const carouselSettings = {
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      adaptiveHeight: true,
      mobileFirst: true
    };

    return (
      <CarouselWrapper>
        <SimpleCarousel settings={carouselSettings}>
          {heroes.map((hero: any, index: number) =>
            <div key={index}>
              <Wrapper direction={alignment}>
                <Effect image={hero.image_column[0]}>
                  <Figure  />
                  <StripeWrapper className={alignment === 'row' ? 'align-right' : 'align-left'}>
                    <FlowStripe
                      animate={true}
                      textH={'6.6em'}
                      color={'#000000'}
                      rotation={90}
                    />
                  </StripeWrapper>
                </Effect>
                <Content>
                  <Link to={hero.text_column.hero_cta_link.url} target={hero.text_column.hero_cta_link.target}>
                    <ContentContainer>
                      <TitleWrapper>
                        <div>
                          <Title>{hero.text_column.hero_main_text}</Title>
                          { hero.text_column.hero_cta_text &&
                          <ReadMore>{hero.text_column.hero_cta_text}</ReadMore>
                          }
                        </div>
                      </TitleWrapper>

                      <div>
                        <ContentFooterContent>
                          <span>{hero.text_column.bottom_left_text}</span>
                          <span>{hero.text_column.bottom_right_text_copy}</span>
                        </ContentFooterContent>
                      </div>
                    </ContentContainer>
                  </Link>
                </Content>
              </Wrapper>
            </div>
          )}
        </SimpleCarousel>
        <BottomStripe style={{marginTop: '-3px'}}>
          <FlowStripe animate={true} color={'#000000'} />
        </BottomStripe>
      </CarouselWrapper>
    )
  }
};

export default Hero;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/home/components/hero/Hero.tsx